import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';
import loadingIcon from 'assets/images/backoffice/online-store/loading.svg';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { PUSHER_APP_KEY } from 'api/constants';
import { startSyncingProductFlow } from 'actions/onlineStore';
import ShopDetailProductTable from '../ShopDetailProductTable';
import styles from './ProductSyncingInSyncModal.css';

const channelSpecificText = {
  facebook: {
    text: 'Facebook and Instagram Shop',
  },
  google: {
    text: 'Google',
  },
};

class ProductSyncingInSyncModal extends React.Component {
  componentDidUpdate() {
    this._connectToPusher();
  }

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const { shopDetail } = this.props.shop;
    const { shopDetailProducts } = this.props.shop;

    if (!shopDetail) {
      return null;
    }

    const channel = shopDetail.channel.toLowerCase();
    let inSyncItemVariant = 0;
    shopDetailProducts.data.map(
      item => (inSyncItemVariant += item.variants.length)
    );

    return (
      <Modal
        backdrop="static"
        onHide={this.props.onHide}
        show
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
            {this.props.title} <b>{this.props.titleBold}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classNames(styles['dialog-body'])}>
            <div className={classNames('row', styles['header-dialog'])}>
              <div className={classNames('col-md-1')}>
                <img
                  src={loadingIcon}
                  className={classNames(styles['img-loading'])}
                />
              </div>
              <div className={classNames('col-md-10')}>
                <strong>
                  Uploading to {channelSpecificText[channel].text}...
                </strong>
                {channel === 'google' && (
                  <div className={styles['mt-10']}>
                    <i>
                      <div className={styles['fs-14']}>
                        The upload process may take a while. Click <b>"Done"</b>{' '}
                        to close.
                      </div>
                      <div className={styles['fs-14']}>
                        We will continue to upload your product in the
                        background.
                      </div>
                    </i>
                  </div>
                )}
              </div>
            </div>
            <ShopDetailProductTable />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className={styles['dialog-footer']}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.onHide}
            >
              Done
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _connectToPusher() {
    if (this.channel) {
      return;
    }

    const { shop, dispatch } = this.props;
    const { shopDetail } = shop;

    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });

    this.channel = pusher.subscribe(
      `gostore-shop-ext-${shopDetail.channel.toLowerCase()}-${shopDetail.id}`
    );

    this.channel.bind('syncs', () => {
      dispatch(startSyncingProductFlow(shopDetail.id, true));
    });
  }
}

function mapStateToProps(state) {
  return {
    shop: state.onlineStore.shop,
  };
}

export default connect(mapStateToProps)(ProductSyncingInSyncModal);
